
import React, { useCallback, useState, useEffect } from 'react';
import { useFormik } from 'formik';
import izenuAPI from '../../services/izenuAPI';


import { Alert } from '@mui/material';
import AdsBannerCard from './components/AdsBannerCard';
import AdsArtworkCard from './components/AdsArtworkCard';
import AdsMiniPlayerCard from './components/AdsMiniPlayerCard';
import AdsHomeCard from './components/AdsHomeCard';
import AdsAudioCard from './components/AdsAudioCard';
import DeepLinksHelp from './components/DeepLinksHelp';
import { AdSpecHint, AudioSpecHint } from './components/AdSpecHint';
const uuid = () => {

    const alfaNumeric = '1234567890ABCDEFGHIJKLMNOPQRSTUVXWYZabcdefghijklmnopkrstuvxwyz';
    let str = alfaNumeric.split("");
    let str2 = '';
    for (var i = 0; i < 8; i++) {
        str2 += '' + str[Math.ceil(Math.random() * str.length)];
    }
    return str2;
}
export default function Ads() {

    const [loading, setLoading] = useState(true);
    const [banners, setBanners] = useState([]);
    const [playerBanners, setPlayerBanners] = useState([]);
    const [artworkBanners, setArtworkBanners] = useState([]);
    const [homeAds, setHomeAds] = useState([]);
    const [activity, setActivity] = useState(false);
    const [file, setFile] = useState(null);
    const [image, setImg] = useState(null);
    const [ads, setADS] = useState(null);
    const [adsTime, setAdsTime] = useState("");
    const [adsLink, setAdsLink] = useState("");
    // Link aberto só pelo web app. Vazio = o web app usa o mesmo link da app.
    const [adsWebLink, setAdsWebLink] = useState("");
    const [desc, setDesc] = useState("");
    const [title, setTitle] = useState("");
    // 'ad' = publicidade (escondida a assinantes), 'app' = padrão da app (visível a todos)
    const [bannerType, setBannerType] = useState("ad");

    //Artwork
    const [fileArtwork, setFileArtwork] = useState(null);
    const [adsArtworkTime, setAdsArtworkTime] = useState("");
    const [adsArtworkLink, setAdsArtworkLink] = useState("");
    const [descArtwork, setDescArtwork] = useState("");
    const [titleArtwork, setTitleArtwork] = useState("");

    //Player
    const [filePlayer, setFilePlayer] = useState(null);
    const [adsPlayerTime, setAdsPlayerTime] = useState("");
    const [adsPlayerLink, setAdsPlayerLink] = useState("");
    const [descPlayer, setDescPlayer] = useState("");
    const [titlePlayer, setTitlePlayer] = useState("");

    //Home ads

    const [fileHome, setFileHome] = useState(null);
    const [adsHomeTime, setAdsHomeTime] = useState("");
    const [adsHomeLink, setAdsHomeLink] = useState("");
    const [descHome, setDescHome] = useState("");
    const [titleHome, setTitleHome] = useState("");

    //Audio ads
    const [audioAds, setAudioAds] = useState([]);
    const [fileAudio, setFileAudio] = useState(null);
    const [fileAudioCover, setFileAudioCover] = useState(null);
    const [adsAudioTime, setAdsAudioTime] = useState("");
    const [adsAudioLink, setAdsAudioLink] = useState("");
    const [descAudio, setDescAudio] = useState("");
    const [titleAudio, setTitleAudio] = useState("");
    const [audioDurationSec, setAudioDurationSec] = useState(0);

    //Fetch current ads
    const fetchAppAds = useCallback(async () => {
        setLoading(true);
        try {
            const { data: r } = await izenuAPI.get('/admin/ads/fetch.php');
            if (r.response) {
                setBanners(r.ads);
                setPlayerBanners(r.player);
                setArtworkBanners(r.artwork);
                setHomeAds(r.home);
                setAudioAds(r.audio || []);
                //console.log(r);
            }
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        };
        //https://img.gs/pqgzqcgmgv/quality=low/https://dpagz47n4g1lw.cloudfront.net/users/".$value['author_id']."/posts/".$folder."/".$file['file']
    });

    useEffect(() => {
        fetchAppAds();
        //uuid();
    }, []);

    const formik = useFormik({

        initialValues: {

            email: '',
            pwd: '',
            contact: '',

        },

        onSubmit: values => {
            //registerUser(values)

        },

    });

    //Upload banner
    const uploadBanner = useCallback(async () => {
        setActivity(true);
        if (file == null) {
            alert("Não selecionou nenhuma imagem valida!");
            setActivity(false);
            return;
        }
        if (title == "") {
            alert("O titulo é um campo obrigatorio");
            setActivity(false);
            return;
        }
        if (adsTime == "") {
            alert("Por favor selecione o tempo de duração");
            setActivity(false);
            return;
        }

        const formData = new FormData();
        formData.append('file', file);
        formData.append('user_id', 4); // TODO: Dynamic user ID if needed
        formData.append('title', title);
        formData.append('dsc', desc);
        formData.append('link', adsLink);
        formData.append('web_link', adsWebLink);
        formData.append('exp_date', adsTime);
        formData.append('banner_type', bannerType);

        try {
            const { data: result } = await izenuAPI.post(
                `/admin/ads/insert.php`,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }
            );

            if (result.response) {
                setDesc("");
                setAdsLink("");
                setAdsWebLink("");
                setAdsTime("");
                setTitle("");
                setBannerType("ad");
                setFile(null);
                setImg(null); // Clear preview
                alert("Carregado com sucesso!");
                setActivity(false);
                fetchAppAds(); // Refresh list
            } else {
                alert(result.message || "Não possivel carregar ads");
                setActivity(false);
            }
        } catch (err) {
            alert("Não foi possivel carregar ads");
            setActivity(false);
            console.log(err);
        };
    }, [file, image, ads, adsLink, adsTime, title, desc, bannerType, fetchAppAds]);


    const onChangeFile = useCallback((e) => {
        const fileType = e.target.files[0].type;
        const fileSize = e.target.files[0].size;

        if (fileType != "image/png" && fileType != "image/jpeg" && fileType != "image/jpg") {
            alert("Ficheiro invalido");
            return;
        }
        if (fileSize * 0.000001 > 3.5) {
            alert("Ficheiro deve ser inferior a 3Mb");
            return;
        }
        setFile(e.target.files[0]);
        const reader = new FileReader();
        reader.onload = () => {
            setImg(reader.result);
        }
        reader.readAsDataURL(e.target.files[0]);
    });


    const onChangeArtworkFile = useCallback((e) => {
        const fileType = e.target.files[0].type;
        const fileSize = e.target.files[0].size;

        if (fileType != "image/png" && fileType != "image/jpeg" && fileType != "image/jpg") {
            alert("Ficheiro invalido");
            return;
        }
        if (fileSize * 0.000001 > 3.5) {
            alert("Ficheiro deve ser inferior a 3Mb");
            return;
        }
        setFileArtwork(e.target.files[0]);
        const reader = new FileReader();
        reader.onload = () => {
            setImg(reader.result);
        }
        reader.readAsDataURL(e.target.files[0]);
    });
    const onChangePlayerFile = useCallback((e) => {
        const fileType = e.target.files[0].type;
        const fileSize = e.target.files[0].size;

        if (fileType != "image/png" && fileType != "image/jpeg" && fileType != "image/jpg") {
            alert("Ficheiro invalido");
            return;
        }
        if (fileSize * 0.000001 > 3.5) {
            alert("Ficheiro deve ser inferior a 3Mb");
            return;
        }
        setFilePlayer(e.target.files[0]);
        const reader = new FileReader();
        reader.onload = () => {
            setImg(reader.result);
        }
        reader.readAsDataURL(e.target.files[0]);
    });
    const onChangeHomeFile = useCallback((e) => {
        const fileType = e.target.files[0].type;
        const fileSize = e.target.files[0].size;

        if (fileType != "image/png" && fileType != "image/jpeg" && fileType != "image/jpg") {
            alert("Ficheiro invalido");
            return;
        }
        if (fileSize * 0.000001 > 3.5) {
            alert("Ficheiro deve ser inferior a 3Mb");
            return;
        }
        setFileHome(e.target.files[0]);
        const reader = new FileReader();
        reader.onload = () => {
            setImg(reader.result);
        }
        reader.readAsDataURL(e.target.files[0]);
    });

    //Upload banner
    const uploadPlayerAds = useCallback(async () => {
        setActivity(true);
        if (filePlayer == null) {
            alert("Não selecionou nenhuma imagem valida!");
            setActivity(false);
            return;
        }
        if (titlePlayer == "") {
            alert("O titulo é um campo obrigatorio");
            setActivity(false);
            return;
        }
        if (adsPlayerTime == "") {
            alert("Por favor selecione o tempo de duração");
            setActivity(false);
            return;
        }

        const formData = new FormData();
        formData.append('file', filePlayer);
        formData.append('user_id', 4);
        formData.append('title', titlePlayer);
        formData.append('info', descPlayer || ""); // Assuming descPlayer corresponds to info? The original code had empty info. Using empty string to match previous behavior if needed, or descPlayer if available. Original code sent info: ""
        formData.append('link', adsPlayerLink);
        formData.append('exp_date', adsPlayerTime);


        try {
            const { data: result } = await izenuAPI.post(
                `/admin/ads/insertPlayerAds.php`,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }
            );

            if (result.response) {
                alert("Carregado com sucesso!");
                setAdsPlayerLink("");
                setAdsPlayerTime("");
                setTitlePlayer("");
                setFilePlayer(null);
                setImg(null);
                setActivity(false);
                fetchAppAds();
            } else {
                alert(result.message || "Não foi possivel carregar ads");
                setActivity(false);
            }
        } catch (err) {
            alert("Não foi possivel carregar ads!")
            setActivity(false);
            console.log(err);
        };
    }, [filePlayer, adsPlayerLink, adsPlayerTime, titlePlayer, descPlayer, fetchAppAds]);

    //Upload ADS Home
    const uploadHomeAds = useCallback(async () => {
        setActivity(true);
        if (fileHome == null) {
            alert("Não selecionou nenhuma imagem valida!");
            setActivity(false);
            return;
        }
        if (titleHome == "") {
            alert("O titulo é um campo obrigatorio");
            setActivity(false);
            return;
        }
        if (adsHomeTime == "") {
            alert("Por favor selecione o tempo de duração");
            setActivity(false);
            return;
        }

        const formData = new FormData();
        formData.append('file', fileHome);
        formData.append('user_id', 4);
        formData.append('title', titleHome);
        formData.append('info', descHome || "");
        formData.append('link', adsHomeLink);
        formData.append('exp_date', adsHomeTime);

        try {
            const { data: result } = await izenuAPI.post(
                `/admin/ads/insertHomeAds.php`,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }
            );

            if (result.response) {
                alert("Carregado com sucesso!");
                setActivity(false);
                setAdsHomeLink("");
                setAdsHomeTime("");
                setTitleHome("");
                setFileHome(null);
                setImg(null);
                fetchAppAds();
            } else {
                alert(result.message || "Não foi possivel carregar ads");
                setActivity(false);
            }
        } catch (err) {
            alert("Não possivel carregar ads");
            setActivity(false);
            console.log(err);
        };
    }, [fileHome, adsHomeLink, adsHomeTime, titleHome, descHome, fetchAppAds]);

    //Upload banner
    const uploadArtworkAds = useCallback(async () => {
        setActivity(true);
        if (fileArtwork == null) {
            alert("Não selecionou nenhuma imagem valida!");
            setActivity(false);
            return;
        }
        if (titleArtwork == "") {
            alert("O titulo é um campo obrigatorio");
            setActivity(false);
            return;
        }
        if (adsArtworkTime == "") {
            alert("Por favor selecione o tempo de duração");
            setActivity(false);
            return;
        }

        const formData = new FormData();
        formData.append('file', fileArtwork);
        formData.append('user_id', 4);
        formData.append('title', titleArtwork);
        formData.append('info', descArtwork || "");
        formData.append('link', adsArtworkLink);
        formData.append('exp_date', adsArtworkTime);

        try {
            const { data: result } = await izenuAPI.post(
                `/admin/ads/insertArtworkAds.php`,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }
            );

            if (result.response) {
                alert("Carregado com sucesso!");
                setActivity(false);
                setAdsArtworkLink("");
                setAdsArtworkTime("");
                setTitleArtwork("");
                setFileArtwork(null);
                setImg(null);
                fetchAppAds();
            } else {
                alert(result.message || "Não foi possivel carregar ads");
                setActivity(false);
            }
        } catch (err) {
            alert("Não foi possivel carregar ads");
            setActivity(false);
            console.log(err);
        };
    }, [fileArtwork, adsArtworkLink, adsArtworkTime, titleArtwork, descArtwork, fetchAppAds]);

    //Upload Audio ads
    const handleAudioFileChange = useCallback((e) => {
        const f = e.target.files[0];
        if (!f) return;
        setFileAudio(f);
        // Detect duration for UX feedback (not blocking)
        try {
            const audio = new Audio();
            audio.preload = "metadata";
            audio.onloadedmetadata = () => {
                setAudioDurationSec(Math.round(audio.duration || 0));
                URL.revokeObjectURL(audio.src);
            };
            audio.onerror = () => setAudioDurationSec(0);
            audio.src = URL.createObjectURL(f);
        } catch {
            setAudioDurationSec(0);
        }
    }, []);

    const uploadAudioAds = useCallback(async () => {
        setActivity(true);
        if (fileAudio == null) {
            alert("Selecione o ficheiro de áudio!");
            setActivity(false);
            return;
        }
        if (fileAudioCover == null) {
            alert("Selecione a imagem de capa!");
            setActivity(false);
            return;
        }
        if (titleAudio === "") {
            alert("O título é obrigatório");
            setActivity(false);
            return;
        }
        if (adsAudioTime === "") {
            alert("Selecione o tempo de duração da publicidade");
            setActivity(false);
            return;
        }

        const formData = new FormData();
        formData.append("audio", fileAudio);
        formData.append("cover", fileAudioCover);
        formData.append("user_id", 4);
        formData.append("title", titleAudio);
        formData.append("info", descAudio || "");
        formData.append("link", adsAudioLink || "");
        formData.append("exp_date", adsAudioTime);

        try {
            const { data: result } = await izenuAPI.post(
                `/admin/ads/insertAudioAds.php`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (result.response) {
                alert("Publicidade em áudio carregada com sucesso!");
                setFileAudio(null);
                setFileAudioCover(null);
                setTitleAudio("");
                setDescAudio("");
                setAdsAudioLink("");
                setAdsAudioTime("");
                setAudioDurationSec(0);
                fetchAppAds();
            } else {
                alert(result.message || "Não foi possível carregar a publicidade.");
            }
        } catch (err) {
            console.log(err);
            alert("Não foi possível carregar a publicidade.");
        }
        setActivity(false);
    }, [fileAudio, fileAudioCover, titleAudio, descAudio, adsAudioLink, adsAudioTime, fetchAppAds]);


    const deleteAds = useCallback(async (obj) => {

        try {
            const { data: r } = await izenuAPI.post("/ads/delete.php", { ads_id: obj.id, type: obj.type });

            if (r.response) {
                alert("Apagado com sucesso!");
                return;
            }

            alert("Impossivel apagar, tenta mais tarde!");
        } catch (error) {
            alert("Impossivel apagar, tenta mais tarde!");
        }

    }, [adsTime, ads, adsLink]);

    const renderPlayerAds = useCallback(() => {

        if (playerBanners.length > 0) {
            return (<div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-3">{playerBanners.map((e, i) => {
                return (
                    <AdsMiniPlayerCard item={e} onEdited={() => fetchAppAds()} />
                )
            })}</div>)
        } else {
            return (
                <div className="p-2 flex gap-5 h-full w-full flex-row mb-3 items-center  rounded-lg">
                    <span className="text-center block w-full text-sm text-gray-500">
                        Ainda sem publicidades
                    </span>
                </div>
            )
        }

    }, [playerBanners]);

    const renderArtworkAds = useCallback(() => {

        if (artworkBanners.length > 0) {
            return (<div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                {artworkBanners.map((e, i) => {

                    return (
                        <AdsArtworkCard item={e} onEdited={() => fetchAppAds()} />
                    )
                })}
            </div>)
        } else {
            return (
                <div className="p-2 flex gap-5 h-full w-full flex-row mb-3 items-center  rounded-lg">
                    <span className="text-center block w-full text-sm text-gray-500">
                        Ainda sem publicidades
                    </span>
                </div>
            )
        }

    }, [artworkBanners]);


    if (loading) {
        return (<div className="justify-center items-center flex flex-col h-full border p-5 rounded-lg">
            <div role="status">
                <svg aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-yellow-400" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                </svg>
                <span class="sr-only">Loading...</span>
            </div>
            <h1 className="text-amber-500 font-light text-3xl">A carregar...</h1>

        </div>)
    }
    if (activity) {
        return (<div className="justify-center items-center flex flex-col h-full border p-5 rounded-lg">
            <div role="status">
                <svg aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-yellow-400" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                </svg>
                <span class="sr-only">Uploading...</span>
            </div>
            <h1 className="text-amber-500 font-light text-3xl">A fazer upload...</h1>

        </div>)
    }
    return (
        <div className="max-w-6xl mx-auto text-left">
            <h2 className="text-lg sm:text-xl font-bold text-gray-900">Banner slides</h2>
            <div className="mt-3 grid grid-cols-1 lg:grid-cols-2 gap-4 items-start">

                <div className="border rounded-xl p-3 sm:p-5 bg-white lg:max-h-[36rem] lg:overflow-y-auto">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {banners.map((e, i) => {
                            return (
                                <AdsBannerCard item={e} onEdited={() => fetchAppAds()} />
                            )
                        })}
                    </div>
                </div>

                <div className="border rounded-xl p-3 sm:p-5 bg-white">
                    <h3 className="font-semibold text-gray-900 mb-3">Adicionar publicidade</h3>
                    <form onSubmit={(e) => { e.preventDefault(); uploadBanner() }} className='uploadForm'>

                        <label class="block mb-2 text-sm font-medium text-gray-900" for="user_avatar">Upload arquivo</label>
                        <div className='relative mb-6'>
                            <input onChange={onChangeFile} class="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400" accept="image/jpeg,image/png" type="file" />
                            <AdSpecHint type="banner" file={file} />
                        </div>
                        <label for="input-group-1" class="block mb-2 text-sm font-medium text-gray-900 text-left">Titulo</label>
                        <div class="relative mb-6">
                            <input type="text" name="title" value={title} onChange={(e) => { setTitle(e.target.value); }} id="input-group-1" placeholder="Titulo" className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-amber-500 block w-full p-2.5" />
                        </div>
                        <label for="input-group-1" class="block mb-2 text-sm font-medium text-gray-900 text-left">Descrição</label>
                        <div className="relative mb-6">
                            <textarea id="message" rows="4" onChange={(e) => setDesc(e.target.value)} value={desc} class="block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-amber-500 focus:border-amber-500  dark:placeholder-gray-400 dark:focus:ring-amber-500 dark:focus:border-amber-500" placeholder="Adicionar descrição a publicidade"></textarea>
                        </div>
                        <label for="input-group-1" class="block mb-2 text-sm font-medium text-gray-900 text-left">Link</label>
                        <div class="relative mb-6">
                            <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                                <svg class="w-4 h-4 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.213 9.787a3.391 3.391 0 0 0-4.795 0l-3.425 3.426a3.39 3.39 0 0 0 4.795 4.794l.321-.304m-.321-4.49a3.39 3.39 0 0 0 4.795 0l3.424-3.426a3.39 3.39 0 0 0-4.794-4.795l-1.028.961" />
                                </svg>
                            </div>
                            <input type="text" name="link" onChange={(e) => setAdsLink(e.target.value)} value={adsLink} id="input-group-1" className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-amber-500 block w-full ps-10 p-2.5" placeholder="Link do ads (opcional)" />
                        </div>
                        <DeepLinksHelp />

                        <label for="banner-web-link" class="block mb-2 text-sm font-medium text-gray-900 text-left">Link exclusivo do web app</label>
                        <div class="relative mb-6">
                            <input type="text" id="banner-web-link" onChange={(e) => setAdsWebLink(e.target.value)} value={adsWebLink} className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-amber-500 block w-full p-2.5" placeholder="/studio/new ou https://... (opcional)" />
                            <p className="mt-1 text-xs text-gray-500 text-left">
                                Só o web app (app.izenu.ao) abre este link. A app do telemóvel continua a abrir o "Link" acima. Vazio = o web app usa o "Link" acima.
                            </p>
                        </div>

                        <label for="banner-type" class="block mb-2 text-sm font-medium text-gray-900 text-left">Tipo de banner</label>
                        <div class="relative mb-6">
                            <select id="banner-type" value={bannerType} onChange={(e) => setBannerType(e.target.value)} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-amber-500 block w-full p-2.5 dark:focus:ring-amber-500 dark:focus:border-amber-500">
                                <option value={'ad'}>📢 Publicidade — não aparece a assinantes</option>
                                <option value={'app'}>📱 Padrão da app — aparece a todos</option>
                            </select>
                            <p className="mt-1 text-xs text-gray-500 text-left">
                                Quem tem assinatura só vê banners "Padrão da app". Utilizadores grátis e visitantes veem todos.
                            </p>
                        </div>

                        <label for="countries" class="block mb-2 text-sm font-medium text-gray-900">Tempo de duração</label>
                        <div class="relative mb-6">
                            <select id="countries" onChange={(e) => setAdsTime(e.target.value)} class="bg-gray-50 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-amber-500 block w-full p-2.5  dark:focus:ring-amber-500 dark:focus:border-amber-500">
                                <option default value={""}>Seleciona a tua opção</option>
                                <option value={'15d'}>15 Dias</option>
                                <option value={'1M'}>1 Mês</option>
                                <option value={'2M'}>2 Meses</option>
                                <option value={'3M'}>3 Meses</option>
                                <option value={'6M'}>6 Meses</option>
                                <option value={'1Y'}>1 Ano</option>
                            </select>
                        </div>
                        <div class="relative mb-6 flex flex-row">

                            {file != null ? (

                                <button type="submit" class="w-full sm:w-auto text-sm px-4 py-2.5 font-medium bg-amber-500 hover:bg-amber-600 rounded-lg">
                                    <span className="!text-white">
                                        Adicionar banner
                                    </span>
                                </button>
                            ) : (<></>)}

                        </div>
                    </form>
                </div>


            </div>
            {/**Player */}
            <h2 className="text-lg sm:text-xl font-bold text-gray-900 mt-8 pt-6 border-t">Publicidades no leitor de reprodução</h2>
            <div className="mt-3 grid grid-cols-1 lg:grid-cols-2 gap-4 items-start">

                <div className="border rounded-xl p-3 sm:p-5 bg-white lg:max-h-[36rem] lg:overflow-y-auto">

                    {renderPlayerAds()}

                </div>

                <div className="border rounded-xl p-3 sm:p-5 bg-white">
                    <h3 className="font-semibold text-gray-900 mb-3">Adicionar publicidade</h3>
                    <form onSubmit={(e) => { e.preventDefault(); uploadPlayerAds() }} className='uploadForm'>

                        <label class="block mb-2 text-sm font-medium text-gray-900" for="user_avatar">Upload arquivo</label>
                        <div className='relative mb-6'>
                            <input onChange={onChangePlayerFile} class="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400" accept="image/jpeg,image/png" type="file" />
                            <AdSpecHint type="player" file={filePlayer} />
                        </div>
                        <label for="input-group-1" class="block mb-2 text-sm font-medium text-gray-900 text-left">Titulo</label>
                        <div class="relative mb-6">
                            <input type="text" name="title" value={titlePlayer} onChange={(e) => { setTitlePlayer(e.target.value); }} id="input-group-1" placeholder="Titulo" className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-amber-500 block w-full p-2.5" />
                        </div>
                        <label for="input-group-1" class="block mb-2 text-sm font-medium text-gray-900 text-left">Link</label>
                        <div class="relative mb-6">
                            <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                                <svg class="w-4 h-4 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.213 9.787a3.391 3.391 0 0 0-4.795 0l-3.425 3.426a3.39 3.39 0 0 0 4.795 4.794l.321-.304m-.321-4.49a3.39 3.39 0 0 0 4.795 0l3.424-3.426a3.39 3.39 0 0 0-4.794-4.795l-1.028.961" />
                                </svg>
                            </div>
                            <input type="text" name="link" onChange={(e) => setAdsPlayerLink(e.target.value)} value={adsPlayerLink} id="input-group-1" className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-amber-500 block w-full ps-10 p-2.5" placeholder="Link do ads (opcional)" />
                        </div>
                        <DeepLinksHelp />

                        <label for="countries" class="block mb-2 text-sm font-medium text-gray-900">Tempo de duração</label>
                        <div class="relative mb-6">
                            <select id="countries" onChange={(e) => setAdsPlayerTime(e.target.value)} class="bg-gray-50 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-amber-500 block w-full p-2.5  dark:focus:ring-amber-500 dark:focus:border-amber-500">
                                <option default value={""}>Seleciona a tua opção</option>
                                <option value={'15d'}>15 Dias</option>
                                <option value={'1M'}>1 Mês</option>
                                <option value={'2M'}>2 Meses</option>
                                <option value={'3M'}>3 Meses</option>
                                <option value={'6M'}>6 Meses</option>
                                <option value={'1Y'}>1 Ano</option>
                            </select>
                        </div>
                        <div class="relative mb-6 flex flex-row">

                            {filePlayer != null ? (

                                <button type="submit" class="w-full sm:w-auto text-sm px-4 py-2.5 font-medium bg-amber-500 hover:bg-amber-600 rounded-lg">
                                    <span className="!text-white">
                                        Adicionar banner
                                    </span>
                                </button>
                            ) : (<></>)}

                        </div>
                    </form>
                </div>


            </div>
            {/**Home */}
            <h2 className="text-lg sm:text-xl font-bold text-gray-900 mt-8 pt-6 border-t">Publicidades na home</h2>
            <div className="mt-3 grid grid-cols-1 lg:grid-cols-2 gap-4 items-start">

                <div className="border rounded-xl p-3 sm:p-5 bg-white lg:max-h-[36rem] lg:overflow-y-auto">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {homeAds.map((e, i) => {
                            return (
                                <AdsHomeCard item={e} onEdited={() => fetchAppAds()} />
                            )
                        })}
                    </div>
                </div>

                <div className="border rounded-xl p-3 sm:p-5 bg-white">
                    <h3 className="font-semibold text-gray-900 mb-3">Adicionar publicidade</h3>
                    <form onSubmit={(e) => { e.preventDefault(); uploadHomeAds() }} className='uploadForm'>

                        <label class="block mb-2 text-sm font-medium text-gray-900" for="user_avatar">Upload arquivo</label>
                        <div className='relative mb-6'>
                            <input onChange={onChangeHomeFile} class="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400" accept="image/jpeg,image/png" type="file" />
                            <AdSpecHint type="home" file={fileHome} />
                        </div>
                        <label for="input-group-1" class="block mb-2 text-sm font-medium text-gray-900 text-left">Titulo</label>
                        <div class="relative mb-6">
                            <input type="text" name="title" value={titleHome} onChange={(e) => { setTitleHome(e.target.value); }} id="input-group-1" placeholder="Titulo" className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-amber-500 block w-full p-2.5" />
                        </div>
                        <label for="input-group-1" class="block mb-2 text-sm font-medium text-gray-900 text-left">Descrição</label>
                        <div className="relative mb-6">
                            <textarea id="message" rows="4" onChange={(e) => setDescHome(e.target.value)} value={descHome} class="block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-amber-500 focus:border-amber-500  dark:placeholder-gray-400 dark:focus:ring-amber-500 dark:focus:border-amber-500" placeholder="Adicionar descrição a publicidade"></textarea>
                        </div>
                        <label for="input-group-1" class="block mb-2 text-sm font-medium text-gray-900 text-left">Link</label>
                        <div class="relative mb-6">
                            <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                                <svg class="w-4 h-4 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.213 9.787a3.391 3.391 0 0 0-4.795 0l-3.425 3.426a3.39 3.39 0 0 0 4.795 4.794l.321-.304m-.321-4.49a3.39 3.39 0 0 0 4.795 0l3.424-3.426a3.39 3.39 0 0 0-4.794-4.795l-1.028.961" />
                                </svg>
                            </div>
                            <input type="text" name="link" onChange={(e) => setAdsHomeLink(e.target.value)} value={adsHomeLink} id="input-group-1" className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-amber-500 block w-full ps-10 p-2.5" placeholder="Link do ads (opcional)" />
                        </div>
                        <DeepLinksHelp />

                        <label for="countries" class="block mb-2 text-sm font-medium text-gray-900">Tempo de duração</label>
                        <div class="relative mb-6">
                            <select id="countries" onChange={(e) => setAdsHomeTime(e.target.value)} class="bg-gray-50 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-amber-500 block w-full p-2.5  dark:focus:ring-amber-500 dark:focus:border-amber-500">
                                <option default value={""}>Seleciona a tua opção</option>
                                <option value={'15d'}>15 Dias</option>
                                <option value={'1M'}>1 Mês</option>
                                <option value={'2M'}>2 Meses</option>
                                <option value={'3M'}>3 Meses</option>
                                <option value={'6M'}>6 Meses</option>
                                <option value={'1Y'}>1 Ano</option>
                            </select>
                        </div>
                        <div class="relative mb-6 flex flex-row">

                            {fileHome != null ? (

                                <button type="submit" class="w-full sm:w-auto text-sm px-4 py-2.5 font-medium bg-amber-500 hover:bg-amber-600 rounded-lg">
                                    <span className="!text-white">
                                        Adicionar ads
                                    </span>
                                </button>
                            ) : (<></>)}

                        </div>
                    </form>
                </div>


            </div>
            {/**ARtwork */}
            <h2 className="text-lg sm:text-xl font-bold text-gray-900 mt-8 pt-6 border-t">Publicidades na capa da música</h2>
            <div className="mt-3 grid grid-cols-1 lg:grid-cols-2 gap-4 items-start">

                <div className="border rounded-xl p-3 sm:p-5 bg-white lg:max-h-[36rem] lg:overflow-y-auto">
                    {renderArtworkAds()}
                </div>

                <div className="border rounded-xl p-3 sm:p-5 bg-white">
                    <h3 className="font-semibold text-gray-900 mb-3">Adicionar publicidade</h3>
                    <form onSubmit={(e) => { e.preventDefault(); uploadArtworkAds() }} className='uploadForm'>

                        <label class="block mb-2 text-sm font-medium text-gray-900" for="user_avatar">Upload arquivo</label>
                        <div className='relative mb-6'>
                            <input onChange={onChangeArtworkFile} class="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400" accept="image/jpeg,image/png" type="file" />
                            <AdSpecHint type="artwork" file={fileArtwork} />
                        </div>
                        <label for="input-group-1" class="block mb-2 text-sm font-medium text-gray-900 text-left">Titulo</label>
                        <div class="relative mb-6">
                            <input type="text" name="title" value={titleArtwork} onChange={(e) => { setTitleArtwork(e.target.value); }} id="input-group-1" placeholder="Titulo" className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-amber-500 block w-full p-2.5" />
                        </div>
                        <label for="input-group-1" class="block mb-2 text-sm font-medium text-gray-900 text-left">Link</label>
                        <div class="relative mb-6">
                            <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                                <svg class="w-4 h-4 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.213 9.787a3.391 3.391 0 0 0-4.795 0l-3.425 3.426a3.39 3.39 0 0 0 4.795 4.794l.321-.304m-.321-4.49a3.39 3.39 0 0 0 4.795 0l3.424-3.426a3.39 3.39 0 0 0-4.794-4.795l-1.028.961" />
                                </svg>
                            </div>
                            <input type="text" name="link" onChange={(e) => setAdsArtworkLink(e.target.value)} value={adsArtworkLink} id="input-group-1" className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-amber-500 block w-full ps-10 p-2.5" placeholder="Link do ads (opcional)" />
                        </div>
                        <DeepLinksHelp />

                        <label for="countries" class="block mb-2 text-sm font-medium text-gray-900">Tempo de duração</label>
                        <div class="relative mb-6">
                            <select id="countries" onChange={(e) => setAdsArtworkTime(e.target.value)} class="bg-gray-50 border border-gray-300 text-gray-500 text-sm rounded-lg focus:ring-amber-500 block w-full p-2.5  dark:focus:ring-amber-500 dark:focus:border-amber-500">
                                <option default value={""}>Seleciona a tua opção</option>
                                <option value={'15d'}>15 Dias</option>
                                <option value={'1M'}>1 Mês</option>
                                <option value={'2M'}>2 Meses</option>
                                <option value={'3M'}>3 Meses</option>
                                <option value={'6M'}>6 Meses</option>
                                <option value={'1Y'}>1 Ano</option>
                            </select>
                        </div>
                        <div class="relative mb-6 flex flex-row">

                            {fileArtwork != null ? (

                                <button type="submit" class="w-full sm:w-auto text-sm px-4 py-2.5 font-medium bg-amber-500 hover:bg-amber-600 rounded-lg">
                                    <span className="!text-white">
                                        Adicionar banner
                                    </span>
                                </button>
                            ) : (<></>)}

                        </div>
                    </form>
                </div>


            </div>

            {/* Audio ads */}
            <h2 className="text-lg sm:text-xl font-bold text-gray-900 mt-8 pt-6 border-t">Publicidades em áudio</h2>
            <div className="mt-3 grid grid-cols-1 lg:grid-cols-2 gap-4 items-start">
                <div className="border rounded-xl p-3 sm:p-5 bg-white lg:max-h-[36rem] lg:overflow-y-auto">
                    {audioAds && audioAds.length > 0
                        ? audioAds.map((item) => (
                              <AdsAudioCard key={item.id} item={item} onDeleted={() => fetchAppAds()} onEdited={() => fetchAppAds()} />
                          ))
                        : <p className="text-sm text-gray-500">Sem publicidades em áudio.</p>}
                </div>

                <div className="border rounded-xl p-3 sm:p-5 bg-white">
                    <h3 className="font-semibold text-gray-900 mb-3">Adicionar publicidade em áudio</h3>
                    <form onSubmit={(e) => { e.preventDefault(); uploadAudioAds(); }} className="uploadForm">
                        <label className="block mb-2 text-sm font-medium text-gray-900">Ficheiro de áudio</label>
                        <div className="relative mb-2">
                            <input
                                onChange={handleAudioFileChange}
                                type="file"
                                accept=".mp3,audio/mpeg"
                                className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50"
                            />
                        </div>
                        <div className="mb-6">
                            <AudioSpecHint file={fileAudio} durationSec={audioDurationSec} />
                        </div>

                        <label className="block mb-2 text-sm font-medium text-gray-900">Imagem de capa (PNG ou JPEG)</label>
                        <div className="relative mb-6">
                            <input
                                onChange={(e) => setFileAudioCover(e.target.files[0] || null)}
                                type="file"
                                accept="image/png,image/jpeg"
                                className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50"
                            />
                        </div>

                        <label className="block mb-2 text-sm font-medium text-gray-900 text-left">Título</label>
                        <div className="relative mb-6">
                            <input
                                type="text"
                                value={titleAudio}
                                onChange={(e) => setTitleAudio(e.target.value)}
                                placeholder="Título"
                                className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                            />
                        </div>

                        <label className="block mb-2 text-sm font-medium text-gray-900 text-left">Descrição</label>
                        <div className="relative mb-6">
                            <textarea
                                value={descAudio}
                                onChange={(e) => setDescAudio(e.target.value)}
                                placeholder="Descrição"
                                rows={2}
                                className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                            />
                        </div>

                        <label className="block mb-2 text-sm font-medium text-gray-900 text-left">Link</label>
                        <div className="relative mb-2">
                            <input
                                type="text"
                                value={adsAudioLink}
                                onChange={(e) => setAdsAudioLink(e.target.value)}
                                placeholder="Link do ads (opcional)"
                                className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                            />
                        </div>
                        <DeepLinksHelp />

                        <label className="block mb-2 text-sm font-medium text-gray-900">Tempo de duração</label>
                        <div className="relative mb-6">
                            <select
                                value={adsAudioTime}
                                onChange={(e) => setAdsAudioTime(e.target.value)}
                                className="bg-gray-50 border border-gray-300 text-gray-500 text-sm rounded-lg block w-full p-2.5"
                            >
                                <option value={""}>Seleciona a tua opção</option>
                                <option value={"15d"}>15 Dias</option>
                                <option value={"1M"}>1 Mês</option>
                                <option value={"2M"}>2 Meses</option>
                                <option value={"3M"}>3 Meses</option>
                                <option value={"6M"}>6 Meses</option>
                                <option value={"1Y"}>1 Ano</option>
                            </select>
                        </div>

                        <div className="relative mb-6 flex flex-row">
                            {fileAudio && fileAudioCover && (
                                <button type="submit" className="w-full sm:w-auto text-sm px-4 py-2.5 font-medium bg-amber-500 hover:bg-amber-600 rounded-lg">
                                    <span className="!text-white">Adicionar publicidade</span>
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </div>

        </div>);

}
